import { render, staticRenderFns } from "./strageList.vue?vue&type=template&id=15024088&scoped=true&"
import script from "./strageList.vue?vue&type=script&lang=js&"
export * from "./strageList.vue?vue&type=script&lang=js&"
import style0 from "./strageList.vue?vue&type=style&index=0&id=15024088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15024088",
  null
  
)

export default component.exports